<div class="card-body">
  <div class="row">
    <div class="form-group col-md-12">
      <label for="exampleInputEmail1"> Keyword </label>
      <input type="text" class="form-control" (keyup)="ReadData_DeviceBehfa_KeySearch()"
        [(ngModel)]="Search_Code_DeviceBehfa_Table" placeholder="Type here to search...">
    </div>
  </div>

  <div class="row">
    <div class="form-group col-md-6">
      <label for="exampleInputEmail1">Group</label>
      <select  (change)="Read_Second_Device_Group()" name="First_Device_Group_Selected" [(ngModel)]="First_Device_Group_Selected" class="custom-select">
        <option value="0">All</option>
        <option  *ngFor="let item of DataList_First_Device_Group" [value]="item.id" >{{item.title}}</option>
      </select>
    </div>

    <div class="form-group col-md-6">
      <label for="exampleInputEmail1">Subgroup</label>
      <select  [(ngModel)]="Second_Device_Group_Selected" name="Second_Device_Group_Selected" class="custom-select">
        <option value="0">All</option>
        <option  *ngFor="let item of DataList_Second_Device_Group" [value]="item.id" >{{item.title}}</option>
      </select>
    </div>
  </div>

  <div class="row">
    <div class="form-group col-md-12">
      <img *ngIf="Procssing_DeviceBehfa" src="assets/Loading.gif" style="width: 25px;" />
      <button *ngIf="!Procssing_DeviceBehfa" type="button" (click)="ReadData_DeviceBehfa()" class="btn btn-info"
        style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
    </div>
  </div>

  <div class="table-responsive">
    <table class="mb-0 table table-bordered table-3 text-center table-striped">
      <thead style="background-color: #489b39; color: white;">
        <tr>
          <th>#</th>
          <th>System ID</th>
          <th>Description</th>
          <th>Manufacturer</th>
          <th>Model</th>
          <th>Code BEHFA</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of DataList_DeviceBehfa
        | paginate
                : {
                    id: 'DataList_DeviceBehfa',
                    itemsPerPage: 50,
                    currentPage: page,
                    totalItems: (DataList_DeviceBehfa).length
                  }">
          <td>{{DataList_DeviceBehfa.indexOf(item)+1}}</td>
          <td>{{item.code}}</td>
          <td class="EnglishClm">{{item.description}}</td>
          <td class="EnglishClm">{{item.manufacturer}}</td>
          <td class="EnglishClm">{{item.model}}</td>
          <td class="EnglishClm">{{item.codeBEHFA}}</td>
          <td (click)="Set_Selected_DeviceBehfa_Record(item)" *ngIf="!Check_InList(item)" style="cursor: pointer;">
            <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
          </td>
          <td *ngIf="Check_InList(item)">
            <p style="color: green;">Selected</p>
          </td>

        </tr>
      </tbody>
    </table>
  </div>

  <pagination-controls
  id="DataList_DeviceBehfa"
  nextLabel="Next"
  previousLabel="Previous"
  (pageChange)="page = $event"
></pagination-controls>

</div>
